export var FlowState;
(function (FlowState) {
    FlowState["PRELOAD"] = "preload";
    FlowState["PRELOAD_ERROR"] = "preload_error";
    FlowState["CALL_TO_ACTION"] = "call_to_action";
    FlowState["TERMS"] = "terms";
    FlowState["FORM"] = "forms";
    FlowState["LOADING"] = "loading";
    FlowState["COMPLETE"] = "complete";
    FlowState["SUBMIT_ERROR"] = "submit_error";
})(FlowState || (FlowState = {}));
//# sourceMappingURL=types.js.map